
import * as utils from 'app/utils'
import { Config697 } from 'config/697'
import { Config701 } from 'config/701'
import { Config705 } from 'config/705'
import { Config71 } from 'config/71'
import { Config74 } from 'config/74'
import { Config401 } from 'config/401'
import { Config145 } from 'config/145/index'
import { ServerDevConfig } from 'config/dev/ServerDev'
import { ConfigFandf } from 'config/fandf'
import { ConfigNames } from 'config/interfaces'
import { CityOfAbcWebConfig } from 'config/NCPERS/CityOfAbc'
import { ConfigXXX } from 'config/XXX'
import * as _ from 'lodash'
import { Midrange } from './midrange'

//From webpack
declare const CONFIG_NAME: ConfigNames
declare const BUILD_VERSION: string
declare const BUILD_DATE: string

const log = utils.makeDebug(false)

log('Config: ' + CONFIG_NAME + ', version: ' + BUILD_VERSION + ', date: ' + BUILD_DATE)

const qsParams = utils.getQueryParams()
const disableProfileStore = !!qsParams.disableProfileStore
const hasDevQueryParam = !!qsParams.useDev
const resetProfile = !!qsParams.resetProfile
const isDevelopmentMode = location.port === '8008'
let isServerDevMode = false

const setServerDevMode = (newDevMode: boolean) => {
  isServerDevMode = newDevMode
}

/**
 * Keep config decision logic here
 */
const getConfig = () => {
  if (hasDevQueryParam || isServerDevMode) {
    return ServerDevConfig
  }

  switch (CONFIG_NAME) {
    case '697': return Config697
    case '71': return Config71
    case '701': return Config701
    case '705': return Config705
    case 'midrange': return Midrange
    case 'CityOfAbc': return CityOfAbcWebConfig
    case 'XXX': return ConfigXXX
    case 'fandf': return ConfigFandf
    case '401': return Config401
    case '74': return Config74
    case '145': return Config145
    default: throw new Error('Unknown config: ' + CONFIG_NAME)
  }
}
declare global {
  var gtag: any;
}

/**
 * Load the site-level configuration information.
 *
 * @returns a promise to load the site configuration.
 */
const loadSiteConfig = () => loadCustomerConfig(CONFIG_NAME)

const loadCustomerConfig = (customerName: string) => {
  if (!customerName) { return Promise.resolve(getConfig()) }
  log('loading configuration for: ' + customerName)
  return fetch('/siteConfigs/' + customerName + '.json')
  .then((x) => {
      if (x.status !== 200) {
          throw new Error('unable to load site configuration information for ' + customerName + '!')
      }
      return x.json()
  })
  .then((x) => {
      if (x.GATrackingID) {
        const w = window as any
        w.dataLayer = w.dataLayer || []
        gtag('js', new Date())
        gtag('config', x.GATrackingID)
      }
      log('Merging info from ' + customerName + ': ' + JSON.stringify(x.Brand, undefined, 4))
      const currentConfig = getConfig()
      const r = _.merge(getConfig(), x)
      log('new config: ' + JSON.stringify(r.Brand, undefined, 4))
      return r
  })
}

const getGATrackingID = () => getConfig().GATrackingID
const getPipelineConfig = () => getConfig().Pipeline
const getWebServicesConfig = () => getConfig().WebServices
const getRegistationInputs = () => getConfig().RegistrationInputs
const getBrandInfo = () => getConfig().Brand
const getBrandHelpers = () => getConfig().BrandHelpers
const configName = CONFIG_NAME
const buildVersion = BUILD_VERSION

export {
  loadCustomerConfig,
  loadSiteConfig,
  buildVersion,
  configName,
  disableProfileStore,
  getGATrackingID,
  getPipelineConfig,
  getWebServicesConfig,
  getRegistationInputs,
  hasDevQueryParam,
  getBrandInfo,
  getBrandHelpers,
  resetProfile,
  isDevelopmentMode,
  setServerDevMode
}



// WEBPACK FOOTER //
// ./src/config/index.ts